import * as Teams from '@microsoft/teams-js';
import { useEffect } from 'react';
import { TeamsInitializationStatus } from '../hosts/IHost';
import { EntryPoint, LogCategory, ScenarioName, StatusName, StepName } from '../logger';
import { getAppHost } from '../utilities/TeamsUtils';

export function useCloseKeydown(entryPoint: EntryPoint): void {
    useEffect((): (() => void) => {
        if (entryPoint === EntryPoint.ComposeExtension) {
            // handle 'Escape' key event in compose extension task module
            // NOTE When in compose extension task module, Approvals App is in a iframe, keyboard event inside will not
            // bubble to parent. This means if the focus is inside Approvals App in task module, press 'Esc' button
            // can't dismiss the task module.
            const closeTaskModule = (e: KeyboardEvent): void => {
                if (e.key === 'Escape') {
                    Teams.dialog.url.submit();
                }
            };

            addEventListener('keydown', closeTaskModule);

            return (): void => {
                removeEventListener('keydown', closeTaskModule);
            };
        }
    }, [entryPoint]);
}

export function useNotifySuccessInCreatRequest(entryPoint: EntryPoint, isNewView?: boolean): void {
    useEffect((): void => {
        const logger = getAppHost().getLogger();
        if (entryPoint === EntryPoint.ComposeExtension) {
            logger.logTraceInfo(
                LogCategory.AppBoot,
                `Notifying Teams for init success in create ${isNewView ? 'requestV2' : 'request'}`
            );
            getAppHost().notifyTeamsInitialization(TeamsInitializationStatus.Success);

            logger.markScenario(
                ScenarioName.AppBoot,
                isNewView ? StepName.AppBootCreateRequestV2Rendered : StepName.AppBootCreateRequestRendered,
                StatusName.NA
            );
            logger.stopScenario(ScenarioName.AppBoot);
        }
    }, [entryPoint, isNewView]);
}
